import type { PluginRouteFactory } from "@d12labs/plugins/types";
import { createRoute } from "@tanstack/react-router";
import { lazy } from "react";

const WorkspacesPage = lazy(() =>
	import("./pages/workspaces.page").then((m) => ({ default: m.WorkspacesPage })),
);
const WorkspacePage = lazy(() =>
	import("./pages/workspace.page").then((m) => ({ default: m.WorkspacePage })),
);

export const createPluginRoutes: PluginRouteFactory = (parentRoute) => [
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/kb",
		component: WorkspacesPage,
	}),
	createRoute({
		getParentRoute: () => parentRoute,
		path: "/kb/$workspaceId",
		component: WorkspacePage,
	}),
];
